import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Questions} from '../../../models/questions.interface';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {GenericDialogComponent} from '../../../../shared/components/generic-dialog/generic-dialog.component';
import {appConfig} from '../../../../config/config';
import {EditQuestionsComponent} from '../edit-questions/edit-questions.component';
import {CreateQuestionsComponent} from '../create-questions/create-questions.component';
import {Master} from '../../../../admin/models/master.interface';

@Component({
  selector: 'app-questions-table',
  templateUrl: './questions-table.component.html',
  styleUrls: ['./questions-table.component.scss']
})
export class QuestionsTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['shortCode', 'description', 'category.description', 'questionType', 'edit'];

  @Input()
  categories!: Master[];
  @Input()
  questions!: Questions[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadQuestions: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  updateQuestionStatus: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadQuestions.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadQuestions.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  addQuestion(): void {
    const dialogRef = this.dialog.open(CreateQuestionsComponent, {data: this.categories, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.createEvent.subscribe(() => {
      this.loadQuestions.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  editQuestion(value: Questions): void {
    const dialogRef = this.dialog.open(EditQuestionsComponent, {data: {question: value, categories: this.categories}, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.editEvent.subscribe(() => {
      this.loadQuestions.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  updateQuestion(question: Questions): void {
    const dialogRef = this.dialog.open(GenericDialogComponent,
      {
        data:
          {
            title: `${question.status === 'ACTIVE' ? 'Disable' : 'Enable'} Question`,
            text: `Are you sure you want to ${question.status === 'ACTIVE' ? 'deactivate' : 'activate'} the selected item?`
          }
      });
    dialogRef.componentInstance.confirm.subscribe((confirm: boolean) => {
      if (confirm) {
        this.updateQuestionStatus.emit(question.id);
      }
      dialogRef.close();
    });
  }

}
